// extracted by mini-css-extract-plugin
export default {"notes":"booking_notes_notes__L4bCg"};